import { API, graphqlOperation } from "aws-amplify";
import * as queries from '../graphql/queries';

async function fetchAllCreditNotes(order_number) {
  let nextToken = null;
  let allCreditNotes = [];
  const filter = {
    order_number: {
      eq: order_number
    }
  };

  do {
    const response = await API.graphql(graphqlOperation(queries.listCreditNotes, {
      filter,
      limit: 1000,
      nextToken: nextToken
    }));

    allCreditNotes = allCreditNotes.concat(response.data.listCreditNotes.items);
    nextToken = response.data.listCreditNotes.nextToken;
  } while (nextToken);

  return allCreditNotes;
}

export const generateCreditNoteNumber = async (order_number) => {
  const creditNotes = await fetchAllCreditNotes(order_number);
  for (let i = 1; i < 100; i++) {
    const credit_note_number = order_number + '_CR' + i;
    const creditNote = creditNotes.find(creditNote => creditNote.credit_note_number === credit_note_number);
    if (!creditNote) {
      return credit_note_number;
    }
  }
}